export default __webpack_public_path__ + "static/media/team_penguin_3.98860d53.jpg";